export default () => {
	const isFront = document.querySelector('body.page-template-front-page');
	const fadeEls = document.querySelectorAll('[data-fade="up"]');
	const multiply = isFront ? 175 : 350;
	if (fadeEls.length > 0) {
		fadeEls.forEach( el => el.style.opacity = 0);
		setTimeout(() => {
			const fadeUp = 'opacity: 1; transform: translateY(0);';
			for (let i = 0; i < fadeEls.length; i++) {
				let time = multiply * i;
				const show = fadeEls[i];
				setTimeout(() => {
					show.style = fadeUp;
				}, time);
			}
		}, 300);
	}
}